import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import TwoFactorRecoverySupportForm from './TwoFactorRecoverySupportForm';
import { sendTwoFactorRecoveryEmail, initNameTagRecovery, initNameTagRecoveryCancel } from '../../actions/twoFactorRecovery';
import { getIsRecovering, getRecoveryAttempted, getRecoveryExpired, getRecoverySent, getIsRecoveryEmailToSupportInErrorState, getRecoveryNeedsSupport, getIsNameTagInitSuccessful, getNameTagId, getIsUngatedForNametag
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../selectors/TwoFactorRecovery';
import { getEmail, getToken } from '../../selectors/TwoFactorAuth';
import TwoFactorNametagRecoveryForm from './TwoFactorNametagRecoveryForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TwoFactorRecoveryPage extends Component {
  constructor(props) {
    super(props);
    this.handleNametagRecoveryInit = () => {
      if (this.props.token) {
        this.props.initNameTagRecovery(this.props.token);
      }
    };
    this.handleSubmit = event => {
      event.preventDefault();
      const {
        token
      } = this.props;
      this.props.sendTwoFactorRecoveryEmail(token);
    };
    this.state = {
      supportRecovery: false
    };
    this.renderButtons = this.renderButtons.bind(this);
    this.handleNametagRecoveryInit = this.handleNametagRecoveryInit.bind(this);
  }
  componentDidMount() {
    const {
      token
    } = this.props;
    if (token === null) {
      this.props.history.push('/');
    }
  }
  renderButtons() {
    const showButtons = !this.state.supportRecovery && !this.props.isNameTagInitSuccessful && this.props.isUngatedForNametag;
    return showButtons ? /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          as: "h1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoveryNameTag.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoveryNameTag.description"
          })
        })]
      }), /*#__PURE__*/_jsx(Spacer, {
        space: "1200"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: () => this.handleNametagRecoveryInit(),
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoveryNameTag.primaryButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: () => this.setState({
            supportRecovery: true
          }),
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoveryNameTag.secondaryButton"
          })
        })]
      })]
    }) : null;
  }
  render() {
    const {
      token
    } = this.props;
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "TWO_FACTOR_SUPPORT_RECOVERY_LOAD",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        flexDirection: "column",
        paddingBlockStart: "500",
        children: /*#__PURE__*/_jsxs(View, {
          maxInlineSize: "500px",
          children: [this.renderButtons(), (!this.props.isUngatedForNametag || this.state.supportRecovery) &&
          /*#__PURE__*/
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          _jsx(TwoFactorRecoverySupportForm, Object.assign({
            onSubmit: this.handleSubmit
          }, this.props)), this.props.isNameTagInitSuccessful && token && /*#__PURE__*/_jsx(TwoFactorNametagRecoveryForm, {
            stopNametagRecovery: this.props.initNameTagRecoveryCancel,
            token: token
          })]
        })
      })
    });
  }
}
TwoFactorRecoveryPage.propTypes = {
  history: PropTypes.object.isRequired,
  sendTwoFactorRecoveryEmail: PropTypes.func.isRequired,
  initNameTagRecovery: PropTypes.func.isRequired,
  initNameTagRecoveryCancel: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  isRecovering: PropTypes.bool.isRequired,
  recoveryAttempted: PropTypes.bool.isRequired,
  recoveryExpired: PropTypes.bool.isRequired,
  recoverySent: PropTypes.bool.isRequired,
  isRecoveryEmailInErrorState: PropTypes.bool.isRequired,
  token: PropTypes.string,
  isNameTagInitSuccessful: PropTypes.bool,
  isUngatedForNametag: PropTypes.bool,
  nameTagId: PropTypes.string
};
const mapStateToProps = state => ({
  email: getEmail(state),
  isRecovering: getIsRecovering(state),
  recoveryAttempted: getRecoveryAttempted(state),
  recoveryExpired: getRecoveryExpired(state),
  recoveryNeedsSupport: getRecoveryNeedsSupport(state),
  recoverySent: getRecoverySent(state),
  isRecoveryEmailInErrorState: getIsRecoveryEmailToSupportInErrorState(state),
  token: getToken(state),
  nameTagId: getNameTagId(state),
  isNameTagInitSuccessful: getIsNameTagInitSuccessful(state),
  isUngatedForNametag: getIsUngatedForNametag(state)
});
const reduxConnect = connect(mapStateToProps, {
  sendTwoFactorRecoveryEmail,
  initNameTagRecovery,
  initNameTagRecoveryCancel
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof TwoFactorRecoveryPage' is... Remove this comment to see the full error message
export default reduxConnect(TwoFactorRecoveryPage);